import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";
import {
  RoleDetailResp,
  RolePageReq,
  RolePageResp,
  RolePermissionDetailResp,
  RolePermissionReq,
  RoleReq,
  RoleSimpleListResp,
} from "./role.interface";
import { useStore } from "@/store";
export class RoleService {
  static usePageApi() {
    const api = (params: RolePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/role/page",
        params,
      });
    return HttpService.usePagination<RolePageResp>(api);
  }

  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/role/simple/list",
      });
    return HttpService.useRequest<RoleSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/role/${id}`,
      });
    return HttpService.useRequest<RoleDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: RoleReq) =>
      HttpService.axios({
        method: "POST",
        url: "/role",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: RoleReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/role/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/role/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static usePermissionDetailApi() {
    const api = (roleId: string) =>
      HttpService.axios({
        method: "GET",
        url: `/role_permissions/${roleId}`,
      });
    return HttpService.useRequest<RolePermissionDetailResp>(api);
  }

  static usePermissionCreateApi() {
    const api = (roleId: string, data: RolePermissionReq) =>
      HttpService.axios({
        method: "POST",
        url: `/role_permissions/${roleId}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useImportApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/role/import",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const store = useStore()
    const belongSystem = store.state?.user?.belongSystem || ''
    const api = () =>
      HttpService.axios({
        method: "POST",
        url: `/role/export?belongSystem=${belongSystem}`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static useUploadRole() {
    const store = useStore()
    const belongSystem = store.state?.user?.belongSystem || ''
    const api = (url) =>
      HttpService.axios({
        url: "/role/importBatchCheck",
        data: {
          url,
          belongSystem,
        },
        method: "post",
      });
    return HttpService.useRequest<any>(api);
  }

  static useFinishUpload() {
    const store = useStore()
    const belongSystem = store.state?.user?.belongSystem || ''
    const api = (data) =>{
      const reqData = data.map(item=>({...item,belongSystem}))
      return HttpService.axios({
        url: "/role/importBatchAdd",
        data: reqData,
        method: "post",
      });
    }
    return HttpService.useRequest<void>(api);
  }
}
